<template>
  <div>
    <div id="comfort-gauge" class="comfort-gauge"></div>
  </div>
</template>
<script>
import Chart from "@/components/charts";
import { onMounted, onUnmounted, ref } from "vue";
export default {
  name: "comfort-gauge",
  props: {
    count: Number
  },
  setup(props) {
    const { count } = props;
    const echart = ref({});
    onMounted(() => {
      echart.value = Chart.setGaugeWarning("comfort-gauge", count);
    });

    onUnmounted(() => {
      echart.value.remove();
    });
  }
};
</script>
<style lang="less">
.comfort-gauge {
  width: 160px;
  height: 160px;
  margin: 0 auto;
}
</style>
